export * from './zoocasa.tenant';
export * from './exp-realty-ca.tenant';
export * from './exp-realty-us.tenant';
export * from './exp-commercial.tenant';
export * from './exp-in-service.tenant';

import { EXP_IN_SERVICE_TENANT_ID } from './exp-in-service.tenant';
import { ZOOCASA_TENANT_ID } from './zoocasa.tenant';
import { EXP_REALTY_CA_TENANT_ID } from './exp-realty-ca.tenant';
import { EXP_REALTY_US_TENANT_ID } from './exp-realty-us.tenant';
import { EXP_COMMERCIAL_TENANT_ID } from './exp-commercial.tenant';

export const tenantIds = [
  ZOOCASA_TENANT_ID,
  EXP_REALTY_CA_TENANT_ID,
  EXP_REALTY_US_TENANT_ID,
  EXP_COMMERCIAL_TENANT_ID,
  EXP_IN_SERVICE_TENANT_ID,
] as const;

export type TenantId = typeof tenantIds[number];